import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import ReportUsersDefaultPage from "./Pages/ReportUsersDefaultPage";
import ReportUsersWizardPage from "./Pages/ReportUsersWizardPage";

const ReportUsersRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/wizard`}>
                <ReportUsersWizardPage />
            </Route>
            <Route path={`${path}/:staffIdFromParams/wizard`}>
                <ReportUsersWizardPage />
            </Route>
            <Route default>
                <ReportUsersDefaultPage />
            </Route>
        </Switch>
    );
};

export default ReportUsersRouter;
